import { Component, AfterViewInit, EventEmitter, ElementRef, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';

import { MessageService } from '../../../core';

@Component({
    selector: 'sgt-tokenfield',
    templateUrl: './tokenfield.component.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TokenfieldComponent), multi: true }
    ]
})
export class TokenfieldComponent implements AfterViewInit, ControlValueAccessor {
    @Input() ngModel: any[];
    @Output() ngModelChange = new EventEmitter<any[]>();

    // Options do Bootstrap Tokenfield
    @Input() limit = 0;
    @Input() minLength = 0;
    @Input() minWidth = 60;
    @Input() autocomplete = {};
    @Input() showAutocompleteOnFocus = false;
    @Input() typeahead = [];
    @Input() createTokensOnBlur = false;
    @Input() delimiter = ',';
    @Input() beautify = true;
    @Input() inputType = 'text';


    @Input() name: any;
    @Input() id: any;
    @Input() allowDuplicates = false;
    @Input() tokenDuplicateMessage: string;
    @Input() validateEmail = false;
    @Input() required: any;
    @Input() disabled: any;
    @Input() readonly: any;
    @Input() placeholder = '';
    @Input() ngControl: NgControl;
    /** Se deve exibir como input group */
    @Input() inputGroup = false;
    /** Icon do input group */
    @Input() inputGroupIcon: string;
    /** Text do input group */
    @Input() inputGroupText: string;
    /** Se deve criar os tokens em Lower Case */
    @Input() lowercase = false;
    /** Se deve criar os tokens em Upper Case */
    @Input() uppercase = false;
    /** Se deve seter o foco automaticamente */
    @Input() autofocus = false;

    // Events
    @Output() createdtoken = new EventEmitter<any>(); // Ao criar um novo token
    @Output() removedtoken = new EventEmitter<any>(); // Ao remover um toke


    @ViewChild('inputTokenfield') inputTokenfield: ElementRef;
    tokenfield: any;
    propagateChange: any = () => {};

    constructor(private el: ElementRef,
                private messageService: MessageService) { }

    ngAfterViewInit() {
        // Criando o Bootstrap Tokenfield
        this.tokenfield = (jQuery(this.inputTokenfield.nativeElement) as any).tokenfield({
            tokens: [],
            limit: this.limit,
            minLength: this.minLength,
            minWidth: this.minWidth,
            autocomplete: this.autocomplete,
            showAutocompleteOnFocus: this.showAutocompleteOnFocus,
            typeahead: this.typeahead,
            createTokensOnBlur: this.createTokensOnBlur,
            delimiter: this.delimiter,
            beautify: this.beautify,
            inputType: this.inputType
        })
        .on('tokenfield:createtoken', (e) => { // Antes de criar um token
            if (e.attrs) {
                // Lower Case
                if (this.lowercase) {
                    e.attrs.value = e.attrs.value.toLowerCase();
                    e.attrs.label = e.attrs.label.toLowerCase();
                }
                // Upper Case
                if (this.uppercase) {
                    e.attrs.value = e.attrs.value.toUpperCase();
                    e.attrs.label = e.attrs.label.toUpperCase();
                }
            }

            // Valida duplicação de token
            if (!this.allowDuplicates) {
                const tokens: any[] = this.tokenfield.tokenfield('getTokens');
                tokens.forEach(token => {
                    if (token.value === e.attrs.value) {
                        // Se tiver uma mensagem de duplicação, exibimos ela...
                        if (this.tokenDuplicateMessage) {
                            this.messageService.info(this.tokenDuplicateMessage, 'Informação');
                        }

                        e.preventDefault();
                    }
                });
            }
        })
        .on('tokenfield:createdtoken', (e) => { // Ao criar um token
            // Se for para validar um e-mail
            if (this.validateEmail) {
                const re = /\S+@\S+\.\S+/
                const valid = re.test(e.attrs.value)
                if (!valid) {
                    jQuery(e.relatedTarget).addClass('invalid')
                }
            }

            this.propagateChange(this.getTokensValues());
            this.validateControl();
            this.createdtoken.emit(e && e.attrs ? e.attrs.value : null);
        })
        .on('tokenfield:removedtoken', (e) => { // Ao deletar um token
            this.propagateChange(this.getTokensValues());
            this.validateControl();
            this.removedtoken.emit(e && e.attrs ? e.attrs.value : null);
        });

        if (this.autofocus) {
           this.setFocus();
        }
    }

    /** Seta o focu no tokenfield */
    setFocus() {
        jQuery(this.el.nativeElement).find('.token-input').focus();
    }

    /** Extrai os valores dos tokens do tokenfield */
    private getTokensValues(): any[] {
        const tokens = this.tokenfield.tokenfield('getTokens');
        if (!tokens) {
            return [];
        }

        const tokensValues = [];
        tokens.forEach(token => tokensValues.push(token.value));
        return tokensValues;
    }

    /** Seta o token ou conjunto de tokens informado(s) */
    setTokens(tokens: any) {
        this.tokenfield.tokenfield('setTokens', tokens);
    }

    /** Adiciona o token informado */
    createToken(token: any) {
        this.tokenfield.tokenfield('createToken', token);
    }

    /** Remove o token informado */
    removeToken(token: any) {
        const tokens = this.getTokensValues();
        if (tokens) {
            const index = tokens.findIndex(value => value === token);
            if (index > -1) {
                tokens.splice(index, 1);
                this.setTokens(tokens);
                this.propagateChange(this.getTokensValues());
                this.validateControl();
            }
        }
    }

    /** Verifica se o ngControl do tokenfield está valído ou não para adicionar ou não a classe que exibe visualmente um campo inválido */
    private validateControl() {
        if (this.disabled || this.readonly) {
            jQuery(this.el.nativeElement).find('.tokenfield').removeClass('ng-invalid');
            return;
        }

        if (this.ngControl.valid) {
            jQuery(this.el.nativeElement).find('.tokenfield').removeClass('ng-invalid');
        } else {
            jQuery(this.el.nativeElement).find('.tokenfield').addClass('ng-invalid');
        }
    }

    /** Quando recebe um valor */
    writeValue(value) {
        if (!this.tokenfield) {
            return;
        }

        if (value) {
            this.tokenfield.tokenfield('setTokens', value);
        } else {
            this.tokenfield.tokenfield('setTokens', []);
        }

        this.validateControl();
    }

    /** Propaga as alterações realizadas no datepicker */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
